import {css} from 'emotion'

export const ProdibiStyle = (w, h) => css({
  position: 'relative',
  height: h,
  width: w,
  overflow: 'hidden',
  top: 0,
  left: 0,
  'canvas': {
    height: '100%',
    width: '100%',
    background: '#000000', 
    cursor: 'zoom-in',
  },
  '.prodibi-tap': {
    position: 'absolute',
    top: '0px',
    left: '50%',
    height: '50px',
    lineHeight: '50px',
    textAlign: 'center',
    width: '200px',
    background: 'rgba(0,0,0,0.5)',
    color: 'white',
    fontWeight: 'bold',
    letterSpacing: '1px',
    transform: 'translateX(-50%)',
  }
})


// WEBPACK FOOTER //
// ./src/styles/components/prodibi.js